import { render } from "./PixEnd.vue?vue&type=template&id=b086b9e2"
import script from "./PixEnd.vue?vue&type=script&lang=js"
export * from "./PixEnd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__